import react from "react";

import Bobo1 from "../images/commercials/Bobo/KIDSPORTFOLIO_WITHBORDERS_2024_047 copy Large.jpeg";
import Bobo2 from "../images/commercials/Bobo/KIDSPORTFOLIO_WITHBORDERS_2024_048 copy Large.jpeg";
import Bobo3 from "../images/commercials/Bobo/KIDSPORTFOLIO_WITHBORDERS_2024_049 copy Large.jpeg";

const Bobo = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={Bobo1} alt="Bobo Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={Bobo2} alt="Bobo Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={Bobo3} alt="Bobo Commercial Photography - Image 3"/>
                </div>
            </div>
        </div>
    );
}

export default Bobo;